<template>
  <div class="consult-container">
    <div class="search-container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operName" label="用户" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="180" align="center" :formatter="dateFormat">
        </el-table-column>
        <el-table-column prop="businessType" align="center" label="操作类型" width="140">
          <template slot-scope="scope">
            <span>{{ businessTypeDict[scope.row.businessType] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" align="center" label="操作内容">
        </el-table-column>
        <el-table-column prop="jsonResult" align="center" label="操作结果">
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getLogList } from '@/api/logsManagement'
import { businessTypeDict } from '@/data/constant'
export default {
  name: 'AdminStaticsLogs',
  data() {
    return {
      tableLoading: false,
      businessTypeDict,
      formInline: {
        date: ''
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      tableData: []
    };
  },

  mounted() {
    this.loadData()
  },

  methods: {
    // 时间转换
    dateFormat(row) {
      return moment(row.createTime).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    onSubmit() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    async loadData() {
      this.tableLoading = true
      const params = {}
      if (this.formInline.date) {
        params.startTime = moment(this.formInline.date[0]).format('YYYY-MM-DD 00:00:00')
        params.endTime = moment(this.formInline.date[1]).format('YYYY-MM-DD 23:59:59')
      }
      await getLogList({
        pageIndex: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        form: params
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.list
        this.pagination.total = res.data.total
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }
}
</style>